import { createSlice } from '@reduxjs/toolkit';

import { initialState, absencesAdapter } from './absences.state';
import { absencesReducers } from './actions';

export const absences = createSlice({
  name: 'absences',
  initialState: absencesAdapter.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    absencesReducers(builder);
  },
});

export const absencesReducer = absences.reducer;
